<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add AMS Form 1
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.monitoring_date="{ item }">
                                <div class="text-truncate" style="max-width: 300px;">
                                    {{ formatDate(item.monitoring_date) }}
                                </div>
                            </template>
                            <template v-slot:item.agenda="{ item }">
                                <div class="text-truncate" style="max-width: 300px;">
                                    {{ item.agenda }}
                                </div>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showViewDetailsDialog(item)" size="small" variant="outlined" text="View Details" color="green-accent-4" elevation="3" class="mr-2"></v-btn>
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <RecommendationComplianceMatrixDialog ref="recommendationComplianceMatrixDialog" @refresh="init"/>
    <RecommendationComplianceDetailsDialog ref="recommendationComplianceDetailsDialog" @refresh="init"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import RecommendationComplianceMatrixDialog from '../Dialogs/Recommendation&ComplianceMatrixDialog.vue';
import RecommendationComplianceDetailsDialog from '../Dialogs/Recommendation&ComplianceDetailsDialog.vue';

export default defineComponent({
    components: {
        RecommendationComplianceMatrixDialog,
        RecommendationComplianceDetailsDialog
    },
    data () {
        return {
            data: [],
            search: null,
            loading: false,

            headers: [
                { title: 'Date of Monitoring', align: 'start', sortable: true, key: 'monitoring_date' },
                { title: 'Agenda', align: 'start', sortable: true, key: 'agenda' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-matrix/findAllBySemesterSchoolyear/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                    
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.recommendationComplianceMatrixDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.recommendationComplianceMatrixDialog.initUpdate(data)
        },
        showViewDetailsDialog(data){
            this.$refs.recommendationComplianceDetailsDialog.initViewDetails(data)
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>